<!--
발송작업 컴포넌트
-->
<template>
    <div class="p-1rem">

        <!-- 작업안내 -->
        <guide
            class=""
            :ship-prod="shipProd"
            :stock-prod="stockProd"

            @cancel="moveToList"
        ></guide>


        <div class="uk-flex uk-flex-top uk-margin-bottom">
            <div class="uk-width-expand uk-flex uk-flex-middle">
                <!-- 재고상품 -->
                <stock-prod
                    v-if="stockProd"
                    class="uk-width-expand"
                    :stock-prod="stockProd"
                    :stock-out-amount="req.stock_out_amount"
                ></stock-prod>


                <!-- 배송상품 오류정보 -->
                <ship-error
                    v-if="shipError"
                    class="uk-width-expand"
                    :ship-error="shipError"
                ></ship-error>


                <!-- 화살표 -->
                <i v-if="stockProd || shipError" class="material-icons arrow">arrow_forward</i>
            </div>

            <div class="uk-width-3-5">
                <!-- 배송상품 -->
                <ship-prod
                    v-if="shipProd"

                    :ship-prod="shipProd"
                    :ship-house="shipHouse"
                    :ship-error="shipError"
                ></ship-prod>


            </div>

        </div>

        <div class="uk-flex uk-flex-left uk-flex-top">
            <div class="uk-width-expand">
                <!-- 메모영역 -->
                <div class="uk-card uk-card-default simple-card uk-card-small uk-margin-remove">
                    <div class="uk-card-body">

                        <!-- 지난 발송실패내역 -->
                        <old-reqs
                            class="mb-1rem"
                            :ship-prod="shipProd"
                            :old-reqs="oldReqs"
                            v-if="oldReqs.length > 0"
                        ></old-reqs>


                        <!-- 요청메모 -->
                        <memo
                            class="mb-1rem"
                            :memo="req.req_memo"
                            :stock-prod="stockProd"
                        ></memo>


                        <!-- 검수시 요청사항 -->
                        <check-requests
                            v-if="checkRequests.length > 0"
                            class="mb-1rem"
                            :requests="checkRequests"
                        ></check-requests>


                        <!-- 경고 -->
                        <warning
                            :ship-prod="shipProd"
                            :stock-prod="stockProd"
                            :stock-out-amount="req.stock_out_amount"
                        ></warning>

                    </div>
                </div>

            </div>

            <div class="sticky-elem uk-flex uk-flex-top">
                <!-- 발송처리 버튼 -->
                <button
                    class="uk-button uk-button-primary uk-button-large button-success"
                    @click="outDone"
                >
                    <i class="material-icons">done</i>
                    정상(발송처리)
                </button>

                <div class="multi-shipping-warning" v-visible="shipHouse.prod_count > 1">
                    <i class="material-icons">
                        warning
                    </i>
                    (주의) 합배송 상품
                </div>



                <!-- 발송실패 버튼 -->
                <button
                    class="uk-button uk-button-danger uk-button-large button-fail"
                    @click="outFail"
                >
                    <i class="material-icons">error</i>
                    오류(발송실패)
                </button>

            </div>
        </div>



        <!-- 발송완료컴포넌트 -->
        <set-ok
            ref="ok"
            :csrf-token="csrfToken"
            :req="req"
            :list-url="listUrl"
        ></set-ok>

        <!-- 발송실패 컴포넌트 -->
        <set-fail
            ref="fail"
            :csrf-token="csrfToken"
            :req="req"
            :stock-prod="stockProd"
            :ship-prod="shipProd"
            :list-url="listUrl"
        ></set-fail>
    </div>
</template>

<script>
export default {
    components: {
        'guide': require('./guide.vue').default,
        'warning': require('./warning.vue').default,
        'old-reqs': require('./old-reqs.vue').default,
        'memo': require('./memo.vue').default,
        'check-requests': require('./check-requests.vue').default,
        'stock-prod': require('./stock-prod.vue').default,
        'ship-prod': require('./ship-prod.vue').default,
        'ship-error': require('./ship-error.vue').default,

        'set-fail': require('./set-fail.vue').default,
        'set-ok': require('./set-ok.vue').default,
    },
    props: {
        // csrf-token
        csrfToken: String,

        // 발송요청ID
        reqId: Number,

        // 목록 url
        listUrl: {
            type: String,
            default: null,
        },
    },
    data: function () {
        return {
            /**
             * (object) 발송요청 정보
             */
            req: {},

            /**
             * (object) 배송상품 정보
             */
            shipProd: {},

            /**
             * (object) 재고상품 정보
             */
            stockProd: {},

            /**
             * (object) 배송상품 하우스
             */
            shipHouse: {},

            /**
             * (object) 배송상품 오류정보
             */
            shipError: null,

            /**
             * (array) 지난 발송내역
             */
            oldReqs: [],
        };
    },
    mounted: function () {
        this.load();
    },
    computed: {
        /**
         * 배송상품의 검수시 요청사항
         * @return [] 검수요청사항 object 배열
         */
        checkRequests() {
            if (this.shipProd && this.shipProd.check_requests) {
                return this.shipProd.check_requests;
            }

            return [];
        },
    },
    methods: {
        /**
         * 목록으로 돌아가기
         */
        moveToList() {
            if (this.listUrl) {
                $.app.move(this.listUrl);
            } else {
                $.app.move('/regions/' + this.req.region_id + '/out-requests');
            }

        },
        /**
         * 정보조회
         */
        load() {
            // promise 생성
            let p = new Promise((resolve, reject) => {
                //reject('failed !');

                // ajax 옵션
                let opts = {
                    type: 'get',
                    url: '/region-out-requests/' + this.reqId + '/job-info',
                    data: {
                        //'_token': this.csrfToken,
                    },
                    success: (response, textStatus, jqXHR) => {
                        // promise 성공
                        resolve(response);
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            });


            // promise 처리
            p.then((response) => {
                // 결과저장
                this.req = response.req;
                this.shipProd = response.ship_prod;
                this.stockProd = response.stock_prod;
                this.shipHouse = response.ship_house;

                // 배송상품 오류정보는 재고발송이 아닐때만
                this.shipError = !this.stockProd ? response.ship_error : null;

                this.oldReqs = response.old_reqs;

            });
        },

        /**
         * 발송실패
         */
        outFail() {
            this.$refs.fail.form();
        },

        /**
         * 발송완료
         */
        outDone() {
            this.$refs.ok.form();
        },
    },
}
</script>

<style lang="scss" scoped>
.arrow {
    font-size: 6rem;
    color: #666;
}


.title {
    text-align: left;
    width: 12rem;
    color: #000;
    font-size: 1.25rem;

    margin-right: 2rem;

    .material-icons {
        font-size: 1.75rem;
    }
    margin-bottom: 2rem;
}




.sticky-elem {
    position: sticky;
    top: 0;
    //            background-color: #fff;
    //            border: 1px solid #999;
    //            padding: 1rem;

    margin-left: 1rem;

}

// 정상버튼, 오류버튼
.button-success {
    height: 7rem;
    //width: 100%;
    font-size: 1.5rem;
}
.button-fail {
    height: 5rem;
    //width: 100%;
    font-size: 1.5rem;
}

// 합배송 경고
.multi-shipping-warning {
    padding: 1rem;
    background-color: #ffffcc;
    color: #000;
    border: 1px solid #000;
    display: inline-block;
    font-size: 1.25rem;
    .material-icons {
        vertical-align: middle;
        font-size: 1.5rem;
    }

    margin: 0 1rem;
}
</style>